import {Injectable} from '@angular/core';
import {ParentService} from '../../pages/A2-utils/ParentClass/ParentService';
import {Observable} from 'rxjs/Observable';
import {constant} from '../../app.constants';
import {Http} from '@angular/http';
import {RiderAdminuserModel} from '../models/rider-adminuser.model';

@Injectable()
export class RiderAdminuserService extends ParentService {

  constructor(private _http: Http) {
    super();
  }

  get(id: number): Observable<RiderAdminuserModel> {
    return this._http.get(`${constant.URL_RIDER}/${id}`, this.getHeader())
      .map(res => res.json())
      .catch(error => Observable.throw(error.json()));
  }

  getAppData(id: number): Observable<RiderAdminuserModel> {
    return  this._http.get(`${constant.URL_RIDER_ADMIN_USER}/${id}`, this.getHeader())
      .map(res => res.json())
      .catch(error => Observable.throw(error.json()));
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/rider-adminuser.service.ts